// src/api/Dashboard.ts
import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

class Dashboard {
  private axios: AxiosInstance;

  constructor() {
    this.axios = Axios.create({
      baseURL: process.env.VUE_APP_INTERFAZ_AGENTE,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Interceptor para añadir token automáticamente
    this.axios.interceptors.request.use((config: AxiosRequestConfig) => {
      config.headers = config.headers || {};

      const token = localStorage.getItem('TOKEN');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }

      return config;
    });
  }

  // Método principal para obtener la instancia
  public newRequest(): AxiosInstance {
    return this.axios;
  }

  // Método útil para descargar archivos (ej: ZIP) 
  public async downloadZip(endpoint: string, params?: Record<string, unknown>): Promise<Blob> {
    // Construye la query string
  console.log("endpoint", endpoint)
  console.log("params", params)
  const fechaFinal = params?.['fecha_final'];
  const query = fechaFinal ? `?fecha_final=${encodeURIComponent(String(fechaFinal))}` : '';

  const response: AxiosResponse<Blob> = await this.axios.get(endpoint + query, {
    responseType: 'blob',
  });

  return response.data;
  }
}

export const dashboard = new Dashboard();
